<template>
    <div>
        <p>{{ item.value.text }}</p>
        <p v-if="item.value.description">
            {{ item.value.description }}
        </p>
        <p v-if="item.value.subtext" class="subtext typographies-paragraph-small-regular">
            {{ item.value.subtext }}
        </p>
        <div v-if="!forceFullList" class="import-buttons">
            <div
                v-for="value in values.slice(0, item.valueFrom.maxDisplay)"
                :key="getCopyCode(value)"
                class="import-buttons__item"
            >
                <CompassTooltip :content="localizedTexts.copyValue" placement="bottom">
                    <CompassTagInteractive
                        class="import-buttons__tag"
                        variant="selectable"
                        :modelValue="true"
                        :valueLabel="value.label"
                        @change="handleCopyToClipboardWithToast(getCopyCode(value))"
                    />
                </CompassTooltip>
            </div>
        </div>
        <CompassButton
            v-if="forceFullList || values.length > item.valueFrom.maxDisplay"
            :label="localizedTexts.showAllValues"
            type="tertiary"
            size="small"
            @click="showModal(item.valueFrom, values)"
        />
    </div>
</template>
<script>
import { handleCopyToClipboardWithToast } from 'Helpers/stringHelper';
export default {
    props: {
        values: {
            type: Array,
            required: true,
        },
        item: {
            type: Object,
            required: true,
        },
        localizedTexts: {
            type: Object,
            required: true,
        },
        showModal: {
            type: Function,
            required: true,
        },
    },
    computed: {
        forceFullList() {
            return this.item.valueFrom?.forceFullList ?? false;
        },
    },
    methods: {
        handleCopyToClipboardWithToast,
        getCopyCode(value) {
            return value?.copyCode ?? value.label;
        },
    },
};
</script>
